export interface ISolucion {
  id?: string | null;
  nombreConvocatoria?: string | null;
  tipoSolucion?: string | null;
}

export class Solucion implements ISolucion {
  constructor(public id?: string | null, public nombreConvocatoria?: string | null, public tipoSolucion?: string | null) {}

  static fromObject(data: ISolucion): Solucion {
    const solucion = new Solucion();
    for (const [key, value] of Object.entries(data)) {
      solucion[key] = value;
    }
    return solucion;
  }
}
